export default {
  namespaced: true,
  state: {
    usuario: null,
    usuarioProvisorio: null,
    loginCpf: false,
    loginGoogleFacebook: false
  },
  getters: {},
  mutations: {
    usuarioAtual (state, payload) {
      state.usuario = payload
    },
    usuarioLogout (state) {
      state.usuario = null
    },
    usuarioProvisorio (state, payload) {
      state.usuarioProvisorio = payload
    },
    usuarioProvisorioLogout (state) {
      state.usuarioProvisorio = null
    },
    loginCpf (state, payload) {
      state.loginCpf = payload
    },
    loginGoogleFacebook (state, payload) {
      state.loginGoogleFacebook = payload
    },
    limparLoginGoogleFacebook (state) {
      state.loginGoogleFacebook = false
    }
  },
  actions: {
    usuarioAtual ({ commit }, payload) {
      commit('usuarioAtual', payload)
    },
    usuarioLogout ({ commit }, payload) {
      commit('usuarioLogout', payload)
    },
    usuarioProvisorio ({ commit }, payload) {
      commit('usuarioProvisorio', payload)
    },
    usuarioProvisorioLogout ({ commit }, payload) {
      commit('usuarioProvisorioLogout', payload)
    },
    loginCpf ({ commit }, payload) {
      commit('loginCpf', payload)
    },
    loginGoogleFacebook ({ commit }, payload) {
      commit('loginGoogleFacebook', payload)
    },
    limparLoginGoogleFacebook ({ commit }, payload) {
      commit('limparLoginGoogleFacebook', payload)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/usuario.js